import React from 'react';
import { useSelector } from 'react-redux';
import { getParticipantCount } from '../../../base/participants/functions';
import BadgeCounter from '../../../base/toolbox/components/web/BadgeCounter';
const ParticipantsCounter = () => {
    const participantsCount = useSelector(getParticipantCount);
    return React.createElement(BadgeCounter, { count: participantsCount });
};
export default ParticipantsCounter;
